import { render, staticRenderFns } from "./GaoyangMap2.vue?vue&type=template&id=c444561a&scoped=true"
import script from "./GaoyangMap2.vue?vue&type=script&lang=js"
export * from "./GaoyangMap2.vue?vue&type=script&lang=js"
import style0 from "./GaoyangMap2.vue?vue&type=style&index=0&id=c444561a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c444561a",
  null
  
)

export default component.exports